<template>
  <div class="my_slider_layer m-lr-11" @mousedown.stop>
    <p :class="type === 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-if="title" v-text="title" class="title" :style="{ width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth }"></span>
      <el-slider
        class="slider_style module"
        style="width: 120px;margin-right: 10px;"
        v-model="Result"
        :min="min"
        :max="max"
        :step="step"
        @change="change"
        :disabled="disabled"
        :show-tooltip="false"
      ></el-slider>
      <my_input_number
        titleWidth="0"
        :value.sync="inputResult"
        :min="min"
        :max="max"
        size="small"
        :num-type="numType"
        :step="step"
        :symbol="symbol"
        @change="change_input"
      ></my_input_number>
    </p>
  </div>
</template>

<script>
export default {
  name: 'my_slider_index',
  props: {
    titleWidth: { // 组件的标题
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: 'px'
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: { // 输入框的值
      type: Number,
      default: 0
    },
    max: { // 输入框的值
      type: Number,
      default: 10000
    },
    step: { // 步长
      type: Number,
      default: 1
    },
    numType: {
      type: String,
      default: 'int'
    }
  },
  data () {
    return {
      Result: this.value,
      inputResult: this.value,
      isShow: true
    }
  },
  watch: {
    Result (val) {
      this.inputResult = val
      this.$emit('update:value', val);//双向数据绑定
      this.$emit('change', val);
    },
    value (val) {
      this.Result = this.value
    }
  },
  methods: {
    clickEvent (key, value) {
      this[key] = value
      if (!value) {
        this.$nextTick(() => {
          this.$refs.input_new.focus()
        })
      }
    },
    change (val) {
      //抛出一个操作停止后的change事件
      this.$emit('handle_stop_change', val)
    },
    change_input (val) {
      this.Result = Number(val)
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
@import "~@/css/global-variable.scss";
.my_slider_layer {
  .set_one_level,
  .set_two_level {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  /deep/ .el-slider {
    .el-slider__bar {
      background-color: $theme-primary;
    }
    .el-slider__button {
      border-color: $theme-primary;
      background-color: $theme-primary;
    }
  }
  /deep/ .my_input_number_layer {
    .set_two_level {
      margin-bottom: 0;
    }
    // margin-left: 5px;
    // width: 70px;
  }
  .input_display {
    margin-left: 5px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_slider/index.vue